module.exports = require('./tokens.common');